<template>
  <b-card class="p-1">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <div class="d-flex align-items-center" style="gap: 1rem; flex: 1">
        <b-form-group class="mb-0" style="flex: 1; max-width: 500px">
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Wyszukaj po imieniu, nr. telefonu, emailu, adresie" />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''"> Wyczyść </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group class="mb-0" style="min-width: 200px">
          <v-select
            v-model="kindFilter"
            label="value"
            :reduce="option => option.key"
            :clearable="true"
            placeholder="Filtruj po typie"
            :options="kindOptions" />
        </b-form-group>
      </div>
      <b-button
        :to="{ name: 'sale-representatives-create' }"
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        type="submit"
        variant="primary"
        class="btn">
        Dodaj
      </b-button>
    </div>
    <b-table
      responsive
      bordered
      striped
      hover
      :items="filteredSaleRepresentatives"
      :fields="fields"
      :filter="filter"
      :filter-included-fields="filterOn">
      <template #cell(actions)="row">
        <div class="d-flex flex-column">
          <b-button
            :to="{ name: 'sale-representatives-edit', params: { id: row.item.id } }"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="btn table-btn"
            size="sm">
            Edytuj
          </b-button>
          <b-button class="mt-1 table-btn" variant="danger" size="sm" @click="destroy(row.item)"> Usuń </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import NotificationMixin from '@/mixins/NotificationMixin';

import { all, destroy } from '@/http/sale-representatives';

import { AddressFormatter } from '@/formatters/AddressFormatter';
import { FullNameFormatter } from '@/formatters/FullNameFormatter';
import { all as allKindOptions } from '@/constants/enums/sale-representative-kind';
import { all as allCountiesEnum } from '@/constants/enums/counties';

export default {
  mixins: [NotificationMixin],

  data() {
    return {
      saleRepresentatives: [],
      filter: '',
      filterOn: [],
      kindFilter: null,
      kindOptions: allKindOptions(),
      fields: [
        {
          key: 'name',
          label: 'Imię i nazwisko',
          sortable: true,
          sortDirection: 'desc',
          formatter: (value, key, item) => {
            return FullNameFormatter(item);
          },
        },
        { key: 'phone', label: 'Nr telefonu', sortable: true, class: 'text-center' },
        { key: 'email', label: 'Email', sortable: true, class: 'text-center' },
        {
          key: 'kind',
          label: 'Typ',
          sortable: true,
          class: 'text-center',
          formatter: (value) => {
            const option = allKindOptions().find((opt) => opt.key === value);
            return option ? option.value : value;
          },
        },
        {
          key: 'location',
          label: 'Lokalizacja',
          sortable: true,
          class: 'text-center',
          formatter: (value, key, item) => {
            if (item.county && item.county.name) {
              const countyName = allCountiesEnum().find((c) => c.key === item.county.name);
              return countyName ? countyName.value : item.county.name;
            }
            return item.region || '-';
          },
        },
        {
          key: 'city',
          label: 'Adres',
          formatter: (value, key, item) => {
            return AddressFormatter(item);
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true,
        },
        { key: 'actions', label: 'Akcje' },
      ],
    };
  },

  computed: {
    filteredSaleRepresentatives() {
      if (!this.kindFilter) {
        return this.saleRepresentatives;
      }
      return this.saleRepresentatives.filter((rep) => rep.kind === this.kindFilter);
    },
  },

  async mounted() {
    await this.fetchSaleRepresentatives();
  },

  methods: {
    async fetchSaleRepresentatives() {
      try {
        const { data } = await all();

        this.saleRepresentatives = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    destroy(saleRepresentative) {
      this.$swal({
        title: 'Jesteś pewny?',
        text: 'Czy chcesz usunąć tego przedstawiciela handlowego?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Usuń',
        cancelButtonText: 'Anuluj',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          destroy(saleRepresentative.id)
            .then(() => {
              this.showSuccessNotification('Przedstawiciel usunięty', 'Pomyślnie usunięto przedstawiciela handlowego.');
              this.fetchSaleRepresentatives();
            })
            .catch(() => {
              this.showErrorNotification(
                'Problem z usunięciem danych',
                'Wystąpił błąd podczas usuwania przedstawiciela handlowego. Skontaktuj się ze swoim developerem.',
              );
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
